import { Button } from 'components/button';
import { Hero } from 'components/hero';
import { TransformationsSlider } from 'components/transformations-slider';
import FAQPage from 'pages/faq/faq';
import OfferPage from 'pages/offer/offer';
import { ReviewCard, ReviewsSlider } from 'pages/opinions/opinions';
import { allReviews } from '../../constants/opinions-data';
import StarIcon from '@mui/icons-material/Star';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React from 'react';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import HealingIcon from '@mui/icons-material/Healing';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

const helpCards = [
	{
		icon: <FitnessCenterIcon sx={{ fontSize: 28 }} />,
		title: 'Poprawa kondycji i sylwetki',
		description: 'Skuteczne metody treningowe dla każdego — niezależnie od poziomu i celu.',
		image: '/photo_6537.jpg',
		gradient: 'linear-gradient(to top, rgba(176,32,68,0.92) 0%, rgba(124,28,57,0.80) 100%)',
	},
	{
		icon: <HealingIcon sx={{ fontSize: 28 }} />,
		title: 'Rozwiązanie problemów bólowych',
		description: 'Treningi medyczne i rehabilitacyjne — wrócisz do pełnej sprawności.',
		image: '/photo_6568.jpg',
		gradient: 'linear-gradient(to top, rgba(140,93,63,0.92) 0%, rgba(78,52,35,0.80) 100%)',
	},
	{
		icon: <EmojiEventsIcon sx={{ fontSize: 28 }} />,
		title: 'Treningi pełne energii',
		description: 'Ćwiczenia, które są efektywne i motywujące — każdy trening to przyjemność.',
		image: '/photo_6541.jpg',
		gradient: 'linear-gradient(to top, rgba(176,32,68,0.92) 0%, rgba(124,28,57,0.80) 100%)',
	},
	{
		icon: <FavoriteIcon sx={{ fontSize: 28 }} />,
		title: 'Budowanie pewności siebie',
		description: 'Szybko zauważysz zmiany w sylwetce i samopoczuciu — gwarantowane.',
		image: '/photo_6556.jpg',
		gradient: 'linear-gradient(to top, rgba(140,93,63,0.92) 0%, rgba(78,52,35,0.80) 100%)',
	},
];

const longReviews = allReviews.filter(r => r.description.length >= 60);

export const MainPage = () => {
	return (
		<div className="font-montserrat-custom-medium">
			<Hero />

			<section className="py-20 lg:py-32 bg-white">
				<div className="max-w-7xl mx-auto px-6">
					<div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
						<div className="lg:w-1/2">
							<div className="relative">
								<div className="absolute -inset-6 bg-gradient-to-br from-primary-100 to-[#e6d4c0] rounded-[2.5rem] opacity-60" />
								<div className="absolute -inset-2 bg-gradient-to-br from-primary-200 to-[#d4b59a] rounded-[2rem] transform rotate-2 opacity-40" />
								<img
									className="relative rounded-[1.75rem] shadow-soft-lg w-full max-w-md mx-auto object-cover"
									alt="Amelia Pałczyńska"
									src="/photo_6262.jpg"
								/>
								<div className="absolute -bottom-5 -right-5 lg:-right-8 bg-white rounded-2xl shadow-soft-lg p-4">
									<div className="flex items-center gap-3">
										<div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center">
											<span className="text-white text-lg font-bold">4+</span>
										</div>
										<div>
											<div className="font-bold text-gray-800 text-sm">Lata doświadczenia</div>
											<div className="text-xs text-gray-500">od 2022 roku</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="lg:w-1/2 text-center lg:text-left">
							<span className="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-bold mb-4">
								O MNIE
							</span>
							<h2 className="font-bold-custom text-4xl lg:text-5xl text-gray-900 mb-4">
								Kim jestem
								<span className="block text-gradient">i co mnie wyróżnia?</span>
							</h2>
							<p className="text-gray-600 mb-6 leading-relaxed">
								Nazywam się Amelia Pałczyńska i jestem trenerką kobiet oraz instruktorką gimnastyki korekcyjnej.
							</p>
							<p className="text-gray-600 mb-6 leading-relaxed">
								Pomagam kobietom budować silne, sprawne i zdrowe ciało poprzez indywidualnie dopasowany trening siłowy oraz świadomą pracę z ciałem. Pracuję zarówno z osobami początkującymi, jak i z kobietami, które chcą poprawić sylwetkę, wrócić do formy lub pozbyć się bólu kręgosłupa.
							</p>
							<p className="text-gray-600 mb-8 leading-relaxed">
								Prowadzę treningi personalne oraz zajęcia w małych grupach w kameralnym <strong>Studio Sportu Dual</strong>. Stawiam na bezpieczeństwo, skuteczność i indywidualne podejście do każdej podopiecznej.
							</p>
							<Button variant="secondary" isLink href="/about-me">
								POZNAJ MNIE BLIŻEJ
							</Button>
						</div>
					</div>
				</div>
			</section>

			<section className="py-20 lg:py-32 bg-gradient-to-br from-[#faf6f2] via-white to-[#fdf5f4]">
				<div className="max-w-7xl mx-auto px-6">
					<div className="text-center mb-14">
						<span className="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-bold mb-4">
							MOJA POMOC
						</span>
						<h2 className="font-bold-custom text-4xl lg:text-5xl text-gray-900">
							Jak mogę Ci <span className="text-gradient">pomóc?</span>
						</h2>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
						{helpCards.map((card, index) => (
							<div
								key={index}
								className="group relative rounded-3xl overflow-hidden cursor-default"
								style={{ height: '380px' }}
							>
								<div
									className="absolute inset-0 bg-center bg-cover transition-transform duration-700 group-hover:scale-110"
									style={{ backgroundImage: `url(${card.image})` }}
								/>
								<div
									className="absolute inset-0 transition-opacity duration-300"
									style={{ background: card.gradient }}
								/>
								<div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
									<div className="w-12 h-12 bg-white/15 backdrop-blur-sm rounded-xl flex items-center justify-center mb-4 border border-white/20">
										{card.icon}
									</div>
									<h3 className="font-bold text-lg mb-2 leading-snug">
										{card.title}
									</h3>
									<p className="text-white/80 text-sm leading-relaxed font-montserrat-custom-medium">
										{card.description}
									</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="py-20 lg:py-32 bg-white">
				<OfferPage />
			</section>

			<section className="py-20 lg:py-32 bg-gradient-to-br from-[#fdf5f4] to-white">
				<TransformationsSlider />
			</section>

			<section className="py-20 lg:py-32 bg-[#faf6f2]">
				<div className="max-w-7xl mx-auto px-4 sm:px-6">
					<div className="text-center mb-12">
						<span className="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-bold mb-4">
							OPINIE
						</span>
						<h2 className="font-bold-custom text-4xl lg:text-5xl text-gray-900">
							Co mówią o mnie <span className="text-gradient">moje podopieczne?</span>
						</h2>
					</div>

					<div className="hidden lg:block">
						<ReviewsSlider reviews={longReviews} />
					</div>
					<div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-6">
						{longReviews.slice(0, 6).map((review, index) => (
							<ReviewCard key={index} slide={review} />
						))}
					</div>

					<div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-10">
						<Link
							to="/opinions"
							className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft-lg hover:shadow-card-hover hover:scale-105 transition-all duration-300 text-sm"
						>
							Wszystkie opinie →
						</Link>
						<a
							href="https://www.google.com/search?q=Trener+Personalny+-+Amelia+Pa%C5%82czy%C5%84ska+Opinie&rflfq=1&num=20&rldimm=11180015413868640070&tbm=lcl&hl=pl-PL#lkt=LocalPoiReviews"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-flex items-center gap-2 px-7 py-3.5 bg-white border border-gray-200 rounded-full text-gray-700 font-bold shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300 text-sm"
						>
							<StarIcon sx={{ fontSize: 18, color: '#FBBF24' }} />
							Zostaw opinię w Google
							<OpenInNewIcon sx={{ fontSize: 16 }} className="text-gray-400" />
						</a>
					</div>
				</div>
			</section>

			<section className="relative py-24 lg:py-36 overflow-hidden">
				<div className="absolute inset-0">
					<img
						src="/gym.jpg"
						alt=""
						className="w-full h-full object-cover"
					/>
					<div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/80 to-primary-900/70" />
				</div>
				<div className="relative max-w-7xl mx-auto px-6">
					<div className="flex flex-col lg:flex-row items-center justify-between gap-12">
						<div className="text-white text-center lg:text-left">
							<h2 className="font-bold-custom text-4xl lg:text-5xl mb-4">
								Gotowa na zmianę?
							</h2>
							<p className="text-lg text-white/80 max-w-xl font-montserrat-custom-light">
								Jeśli interesuje Cię współpraca ze mną, nie zwlekaj — zapisz się już dziś!
							</p>
						</div>
						<div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
							<Link
								to="/contact"
								className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft-lg hover:shadow-card-hover hover:scale-105 transition-all duration-300 text-center justify-center"
							>
								ZAPISZ SIĘ NA TRENING
								<ArrowForwardIcon fontSize="small" />
							</Link>
							<Link
								to="/offer"
								className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-bold rounded-full hover:bg-white/20 transition-all duration-300 text-center justify-center"
							>
								ZOBACZ OFERTĘ
							</Link>
						</div>
					</div>
				</div>
			</section>

			<section className="py-20 lg:py-32 bg-white">
				<FAQPage />
			</section>
		</div>
	);
};
